import { useContext } from 'react'

import { DateTimePickerContext } from 'components/form/DateTimePicker/helpers'
import theme from 'styles/theme'
import { transformHoursToTwoDigitsString } from 'utils/dates'

import { HourStyleProps } from './styles'

export const getTextColor = ({ isSelected, isDisabled }: HourStyleProps): string => {
  if (isSelected) {
    return theme.token.var('colors.white')
  }

  if (isDisabled) {
    return theme.token.var('colors.gray.300')
  }

  return theme.token.var('colors.initial')
}

export const getBackground = ({ isSelected, isDisabled }: HourStyleProps): string => {
  if (isSelected) {
    return theme.token.var('colors.green.a200')
  }

  if (isDisabled) {
    return theme.token.var('colors.green.a50')
  }

  return theme.token.var('colors.green.a100')
}

export const useAllTimeHelpers = (index: number): { hour: string; isSelected: boolean; isDisabled: boolean } => {
  const { dateTimeState } = useContext(DateTimePickerContext)

  const {
    props: { shouldDisableHour },
    value,
  } = dateTimeState

  const hour = transformHoursToTwoDigitsString(index)
  const isSelected = hour === dateTimeState.value.time

  let currentDay: Date

  if (value.year !== undefined && value.month !== undefined && value.day !== undefined) {
    currentDay = new Date(value.year, value.month, value.day, index)
  } else {
    currentDay = new Date()
  }

  return {
    hour,
    isSelected,
    isDisabled: shouldDisableHour ? shouldDisableHour(hour, currentDay) : false,
  }
}
